import { useState } from "react";
import { CreateFight } from "../../components/admin/CreateFight";
import { CreateGame } from "../../components/admin/CreateGame";
import { CreateLeague } from "../../components/admin/CreateLeague";
import { CreatePlayer } from "../../components/admin/CreatePlayer";
import { CreateTeam } from "../../components/admin/CreateTeam";
import { Button } from "../../components/ui/btns/Button";
import CreateNewFight from "../../components/admin/CreateNewFight";

export const Create = () => {
  const [selectedComponent, setSelectedComponent] = useState("fight");

  const componentSelect = (component) => {
    setSelectedComponent(component);
  };

  const componentMap = {
    game: <CreateGame />,
    league: <CreateLeague />,
    player: <CreatePlayer />,
    team: <CreateTeam />,
    fight: <CreateNewFight />,
  };

  const getComponent = () => {
    return componentMap[selectedComponent] || null;
  };

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange text-center mb-6">
          Create
        </h1>
        <div className="flex flex-wrap gap-3 mb-8 justify-center">
          {["game", "league", "player", "team", "fight"].map((type) => (
            <Button
              key={type}
              onClick={() => componentSelect(type)}
              variant={selectedComponent === type ? "primary" : "secondary"}
            >
              Create {type.charAt(0).toUpperCase() + type.slice(1)}
            </Button>
          ))}
        </div>
        <div>{getComponent()}</div>
      </div>
    </div>
  );
};
